import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "analysis-container" }
const _hoisted_2 = { class: "controls-row" }
const _hoisted_3 = { class: "table-wrapper" }

import { ref, computed, onMounted, watch } from 'vue';
import type { ColumnType } from 'ant-design-vue/es/table';
import { postCompareRankMultiExam } from '@/servers/api/analysis';
import { getGradeApi } from '@/servers/api/grade';
import { getSubjectScore } from '@/utils/subjects'
import { message } from 'ant-design-vue';


interface Exam {id:string,name:string}


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamAnalysis',
  props: {
    student_id: {},
    selected_id: {},
    examList: {},
    studentInfo: {},
    subjects: {}
  },
  emits: ['update:compareScoreData'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const compareExamId = ref<string>('');

onMounted(()=> {
  // 核心：选择切片后列表的第1个（对应原始列表第2个=上一次考试）
  if(props.examList.length >= 1) {
    compareExamId.value = props.examList[0].id;
    handleChange(compareExamId.value);
  }
})
const tableData = ref<{
        subject : any | string,
        rankChangeClass:any,
        rankChangeSegment:any,
    }[]>([])

const render = ({ text }: { text: number | null }) => {
    if (text === null || text === undefined) {
        return '无数据';
    }
    if (text > 0) {
        return `${text}`;
    } else if (text < 0) {
        return `${Math.abs(text)}`;
    }
    return String(text);
}

const customCell = (record: any) => {
    const text = record?.rankChangeSegment;
    const numericText = Number(text);
    if (text === null || text === undefined || isNaN(numericText)) {
        return { style: { color: 'rgba(0, 0, 0, 0.85)' } };
    }
    const color = numericText > 0 ? '#52c41a' : numericText < 0 ? '#f5222d' : 'rgba(0, 0, 0, 0.85)';
    return { style: { color } };
}

// 本次考试表格列定义
const currentExamColumns: ColumnType[] = [
  {
    title: '科目',
    dataIndex: 'subject',
    key: 'subject',
    align: 'center',
  },
  {
    title: '进退班次',
    dataIndex: 'rankChangeClass',
    key: 'rankChangeClass',
    customRender: render,
    customCell: customCell,
    align: 'center',
  },
  {
    title: '进退段次',
    dataIndex: 'rankChangeSegment',
    key: 'rankChangeSegment',
    customRender: render,
    customCell: customCell,
    align: 'center',
  },
];

const handleUpandDown = (res:any) => { 
    tableData.value = []
    if (!res?.data?.[0]) return;
    
    const addSubjectData = (
        subjectName: string,
        rankChangeClassField: any,
        rankChangeSegmentField: any
    ) => {
        if (rankChangeClassField !== undefined || rankChangeSegmentField !== undefined) {
            tableData.value.push({
                subject: subjectName,
                rankChangeClass: rankChangeClassField ?? '无数据',
                rankChangeSegment: rankChangeSegmentField ?? '无数据',
            });
        }
    };

    const selection = props.studentInfo?.subject_selection;
    const hasSelection = typeof selection === 'string' && selection.length > 0;
    const extras = [
        { short: '物', name: '物理' },
        { short: '化', name: '化学' },
        { short: '生', name: '生物' },
        { short: '史', name: '历史' },
        { short: '地', name: '地理' },
        { short: '政', name: '政治' }
    ] as const;

    addSubjectData('总分', res.data[0].compareB['总分班次'], res.data[0].compareD['总分段次']);
    addSubjectData('语文', res.data[0].compareB['语文班次'], res.data[0].compareD['语文段次']);
    addSubjectData('英语', res.data[0].compareB['英语班次'], res.data[0].compareD['英语段次']);
    addSubjectData('数学', res.data[0].compareB['数学班次'], res.data[0].compareD['数学段次']);

    for (const e of extras) {
        if (!hasSelection || selection.includes(e.short)) {
            addSubjectData(
                e.name,
                (res.data[0].compareB as any)[`${e.name}班次`],
                (res.data[0].compareD as any)[`${e.name}段次`]
            );
        }
    }
}
const debounce = (func: Function, wait: number) => {
  let timeout: number | null = null;
  return function (...args: any[]) {
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = window.setTimeout(() => {
      func.apply(null, args);
    }, wait);
  };
};

const loadTableAndRadar = (value:string) => {
  postCompareRankMultiExam({
        selected_exam_id:props.selected_id,
        student_id:props.student_id,
        compare_exam_ids:"'"+value + "'"
    }).then(res => {
        handleUpandDown(res)
    })
    getGradeApi({
      student_id: props.student_id,
      exam_id: parseInt(value),
    }).then((res:{code:number,data:any[],msg:string})=> {
      if(res.code === 200 && res.data?.[0]) {
        const compareScoreData = []
        // 过滤异常成绩
        const safeScore = (score: any, max: number) => isFinite(score) && score <= max ? score : 0;
        for(let i of subjectsList.value){
          const score = getSubjectScore(res.data[0], i.name);
          compareScoreData.push(safeScore(score, i.max));
        }
        emit('update:compareScoreData', compareScoreData);
      }else {
        message.error(res.msg)
      }
    });
}

const debouncedLoadTableAndRadar = debounce(loadTableAndRadar, 300);

const handleChange = (value:string) => {
    compareExamId.value = value;
    debouncedLoadTableAndRadar(value)
}

const subjectsList = computed(() => {
  if (props.subjects && props.subjects.length) return props.subjects;
  const base = [
    { name: '语文', max: 150 },
    { name: '英语', max: 150 },
    { name: '数学', max: 150 }
  ];
  const extra = [{ n:'物', v:'物理' },{ n:'化', v:'化学' },{ n:'生', v:'生物' },{ n:'史', v:'历史' },{ n:'地', v:'地理' },{ n:'政', v:'政治' }];
  const result = [...base];
  for (const i of extra) {
    if (props.studentInfo?.subject_selection?.includes(i.n)) {
      result.push({ name: i.v, max: 100 });
    }
  }
  return result;
});

watch(
  () => props.examList,
  (list) => {
    if (list?.length && !compareExamId.value) {
      compareExamId.value = list[0].id;
      handleChange(compareExamId.value);
    }
  },
  { deep: true }
);

watch(
  () => props.selected_id,
  () => {
    if (compareExamId.value) {
      debouncedLoadTableAndRadar(compareExamId.value);
    }
  }
);

watch(
  () => subjectsList.value,
  () => {
    if (compareExamId.value) {
      debouncedLoadTableAndRadar(compareExamId.value);
    }
  },
  { deep: true }
);


watch(
  () => props.examList,
  (list) => {
    if (list?.length && !compareExamId.value) {
      compareExamId.value = list[0].id;
      handleChange(compareExamId.value);
    }
  },
  { deep: true }
);

watch(
  () => props.selected_id,
  () => {
    if (compareExamId.value) {
      debouncedLoadTableAndRadar(compareExamId.value);
    }
  }
);

watch(
  () => subjectsList.value,
  () => {
    if (compareExamId.value) {
      debouncedLoadTableAndRadar(compareExamId.value);
    }
  },
  { deep: true }
);


return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "label" }, "对比考试：", -1)),
      _createVNode(_component_a_select, {
        placeholder: "请选择考试",
        style: {"min-width":"150px"},
        onChange: handleChange,
        value: compareExamId.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((compareExamId).value = $event)),
        size: "middle"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.examList, (item) => {
            return (_openBlock(), _createBlock(_component_a_select_option, {
              key: item.id,
              value: item.id
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"legend-bar\" data-v-4ca01782><span class=\"legend-item\" data-v-4ca01782><span class=\"dot red\" data-v-4ca01782></span> 退步</span><span class=\"legend-item\" data-v-4ca01782><span class=\"dot green\" data-v-4ca01782></span> 进步</span></div>", 1)),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_table, {
        columns: currentExamColumns,
        "data-source": tableData.value,
        pagination: false,
        size: "middle",
        bordered: "",
        class: "analysis-table"
      }, null, 8, ["data-source"])
    ])
  ]))
}
}

})